import { render, staticRenderFns } from "./AnalyzeConceptBranch.vue?vue&type=template&id=22f9b254&scoped=true&"
import script from "./AnalyzeConceptBranch.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeConceptBranch.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeConceptBranch.vue?vue&type=style&index=0&id=22f9b254&prod&lang=scss&scoped=true&"
import style1 from "./AnalyzeConceptBranch.vue?vue&type=style&index=1&id=22f9b254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9b254",
  null
  
)

export default component.exports